import React, { lazy } from 'react';
import { PageBanner } from '../components/PageBanner';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon, MailIcon, CheckCircleIcon } from 'lucide-react';
export function BookingPage() {
  const features = [{
    icon: CalendarIcon,
    text: 'Choose your preferred date'
  }, {
    icon: ClockIcon,
    text: 'Select a convenient time slot'
  }, {
    icon: MailIcon,
    text: 'Receive email confirmation & reminders'
  }];
  return <main className="bg-white" data-id="element-320">
      <PageBanner title="Book Appointment" subtitle="Schedule your fingerprinting appointment online in just a few clicks." data-id="element-321" />

      <section className="py-16 bg-white" data-id="element-322">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-324">
            {/* Booking Info */}
            <div className="text-center mb-10" data-id="element-325">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F0F4FF] rounded-full border border-[#E7ECF8] mb-4" data-id="element-326">
                <CalendarIcon className="h-4 w-4 text-[#4AA6CF]" data-id="element-327" />
                <span className="text-sm font-medium text-[#1E1F55]" data-id="element-328">
                  Online Scheduling
                </span>
              </div>
              <p className="text-gray-600 max-w-xl mx-auto leading-relaxed mb-6" data-id="element-329">
                Select your preferred service, date, and time below.
                Appointments are scheduled every 15 minutes.
              </p>

              {/* Feature Highlights */}
              <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-330">
                {features.map((feature, i) => <div key={i} className="flex items-center gap-2 text-sm text-gray-500" data-id="element-331">
                    <feature.icon className="h-4 w-4 text-[#4AA6CF]" data-id="element-332" />
                    <span data-id="element-333">{feature.text}</span>
                  </div>)}
              </div>
            </div>

            {/* Zoho Bookings Iframe */}
            <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm bg-gray-50" data-id="element-334">
              <iframe src="https://ambientfingerprintingsolutions.zohobookings.com/portal-embed#/4623993000000036016" width="100%" height="700" title="Book an Appointment - Ambient Fingerprinting" style={{
              border: 0,
              display: 'block',
              minHeight: '600px'
            }} loading="lazy" allowFullScreen data-id="element-335"></iframe>
            </div>

            {/* Pricing Quick Reference */}
            <div className="mt-12 grid sm:grid-cols-2 gap-8 border-t border-gray-100 pt-10" data-id="element-336">
              <div className="flex items-start gap-4" data-id="element-337">
                <div className="bg-slate-50 p-2 rounded-lg" data-id="element-338">
                  <CheckCircleIcon className="h-5 w-5 text-[#4AA6CF]" data-id="element-339" />
                </div>
                <div data-id="element-340">
                  <p className="text-base font-extrabold text-[#1E1F55] mb-1" data-id="element-341">
                    Office Appointment
                  </p>
                  <p className="text-sm text-slate-500 leading-relaxed" data-id="element-342">
                    $65.25 — all fees included
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-343">
                <div className="bg-slate-50 p-2 rounded-lg" data-id="element-344">
                  <CheckCircleIcon className="h-5 w-5 text-[#4AA6CF]" data-id="element-345" />
                </div>
                <div data-id="element-346">
                  <p className="text-base font-extrabold text-[#1E1F55] mb-1" data-id="element-347">
                    Mobile / Group
                  </p>
                  <p className="text-sm text-slate-500 leading-relaxed" data-id="element-348">
                    $70.25 per person — 5+ people
                  </p>
                </div>
              </div>
            </div>

            {/* Help Text */}
            <p className="text-center text-sm text-gray-500 mt-8" data-id="element-349">
              Having trouble booking? Call us directly at{' '}
              <a href="tel:4105255285" className="text-[#4AA6CF] font-medium hover:underline" data-id="element-350">
                410-525-5285
              </a>
            </p>
          </motion.div>
        </div>
      </section>
    </main>;
}